import { render, staticRenderFns } from "./FlowDownAuditRequestView.vue?vue&type=template&id=455e7df5"
import script from "./FlowDownAuditRequestView.vue?vue&type=script&lang=js"
export * from "./FlowDownAuditRequestView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports